import { AccessorialCode } from '@rygen/rygen-ui/model/AccessorialCode';

import { RateQuoteChargeUpliftRuleUnit } from './RateQuoteChargeUpliftRuleUnit';
import { RateUplift } from './RateUplift';

export class RateQuoteAccessorial {
  id?: number;
  code?: AccessorialCode;
  accessorialDescription?: string;
  quantity?: number;
  uom?: string;
  charge?: number;
  upliftedAmount?: number;
  upliftAmount?: number;
  upliftRule?: RateUplift;
  stopSequenceNumber?: number;

  constructor(opts?: Partial<RateQuoteAccessorial>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.code != null) {
      this.code = new AccessorialCode(opts.code);
    }
    if (opts?.accessorialDescription != null) {
      this.accessorialDescription = opts.accessorialDescription;
    }
    if (opts?.quantity != null) {
      this.quantity = opts.quantity;
    }
    if (opts?.uom != null) {
      this.uom = opts.uom;
    }
    if (opts?.charge != null) {
      this.charge = opts.charge;
    }
    if (opts?.upliftedAmount != null) {
      this.upliftedAmount = opts.upliftedAmount;
    }
    if (opts?.upliftAmount != null) {
      this.upliftAmount = opts.upliftAmount;
    }
    if (opts?.upliftRule != null) {
      this.upliftRule = new RateUplift(opts.upliftRule);
    }
    if (opts?.stopSequenceNumber != null) {
      this.stopSequenceNumber = opts.stopSequenceNumber;
    }
  }

  get chargeNaturalId(): string | undefined {
    return this.code?.naturalId;
  }

  get upliftRate(): number {
    return this.upliftRule?.upliftRate ?? 0;
  }

  get upliftRateUnit(): RateQuoteChargeUpliftRuleUnit {
    return RateQuoteChargeUpliftRuleUnit.parse(this.upliftRule?.upliftRateUnit);
  }
}
